import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { getAnimalsE } from "../../../api/animalsApi";
import { AuthContext } from "../../../Contexts/AuthContext";
import './animalsList.css';
import { MdOutlineManageSearch } from "react-icons/md";

export default function AnimalsList() {
  const [animals, setAnimals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setLoading(true);
    getAnimalsE()
      .then(data => setAnimals(data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const filteredAnimals = animals.filter(a => {
    const search = searchTerm.toLowerCase();
    return a.numero?.toString().toLowerCase().includes(search) ||
      a.nom?.toLowerCase().includes(search) ||
      a.race?.nom?.toLowerCase().includes(search) ||
      a.phase?.titre?.toLowerCase().includes(search) ||
      a.poids?.toString().toLowerCase().includes(search) ||
      a.genre?.toLowerCase().includes(search);
  });

  return (
    <div className="animaux">
      <div className="animaux-header">
        <h2>Animaux</h2>
        <div className="animals-count">
          <div className="count-badge">{animals.length}</div>
          <div className="count-label">Animaux</div>
        </div>
        <Link to={'/eleveur/add-animal'} className="add-animal">
          Ajouter un animal
        </Link>
      </div>
      
      <div className="search-container">
        <div className="search-wrapper">
          <input
            type="text"
            className="search-input"
            placeholder="Rechercher par numéro, nom, race, phase, responsable..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <span className="search-icon"><MdOutlineManageSearch /></span>
          {searchTerm && (
            <button
              className="search-clear visible"
              onClick={() => setSearchTerm('')}
            >
              X
            </button>
          )}
        </div>
        {searchTerm && (
          <div className="search-results-info">
            <strong>{filteredAnimals.length}</strong> résultat{filteredAnimals.length !== 1 ? 's' : ''} trouvé{filteredAnimals.length !== 1 ? 's' : ''}
          </div>
        )}
      </div>

      {loading && <p className="loading-messageL">Chargement...</p>}
      {!loading && animals.length === 0 && <p className="Rien-a-faireL">Aucun animal disponible</p>}

      

      {!loading && animals.length > 0 && (
        <div className="table-container">
          {!loading && animals.length > 0 && searchTerm && filteredAnimals.length === 0 && (
            <div className="no-results-message">
              <h3>Aucun résultat trouvé</h3>
              <p>
                Aucun animal ne correspond à votre recherche <span className="search-term">"{searchTerm}"</span>
              </p>
            </div>
          )}
          <table className="animals-table">
            <thead>
              <tr>
                <th>Animal</th>
                <th>Race</th>
                <th>Phase</th>
                <th>Poids</th>
                <th>Genre</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredAnimals.map((a, index) => (
                <tr key={a.id} style={{ '--index': index }}>
                  <td data-label="Animal">
                    <div className="animal-name-cell">
                      <span className="animal-numero">#{a.numero}</span>
                      <span className="animal-nom">{a.nom}</span>
                    </div>
                  </td>

                  <td data-label="Race">
                    <span className="table-badge">
                      {a.race?.nom || a.race_id}
                    </span>
                  </td>

                  <td data-label="Phase">
                    {a.phase?.titre || a.phase_id}
                  </td>

                  <td data-label="Poids">
                    {a.poids ? `${a.poids} kg` : 'Non défini'}
                  </td>

                  <td data-label="Genre">
                    {a.genre || 'Non défini'}
                  </td>

                  <td data-label="Actions">
                    <div className="actions-cell">
                      <Link
                        to={'/eleveur/edit/' + a.id}
                        className="action-btn action-btn-edit"
                      >
                        Modifier
                      </Link>
                      <Link
                        to={'/eleveur/animal/details/' + a.id}
                        className="action-btn action-btn-details"
                      >
                        Détails
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
